/* Expandable product description */
(function() {
  function initExpandableDescriptions(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-np-expandable-description]').forEach(function(container) {
      if (container.dataset.npDescriptionReady === 'true') return;
      container.dataset.npDescriptionReady = 'true';
      var controller = new AbortController();
      container._npCleanup = function () { controller.abort(); };

      var body = container.querySelector('[data-np-description-body]');
      var toggle = container.querySelector('[data-np-description-toggle]');
      var label = container.querySelector('[data-np-description-label]');
      if (!body || !toggle || !label) return;

      var lines = parseInt(getComputedStyle(container).getPropertyValue('--np-description-lines'), 10) || 6;
      var lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 27;
      var collapsedHeight = Math.ceil(lines * lineHeight);
      var expandLabel = container.getAttribute('data-expand-label') || 'Leggi tutta la descrizione';
      var collapseLabel = container.getAttribute('data-collapse-label') || 'Riduci descrizione';

      function collapse(skipFocus) {
        container.classList.remove('is-expanded');
        body.style.maxHeight = collapsedHeight + 'px';
        toggle.setAttribute('aria-expanded', 'false');
        label.textContent = expandLabel;
        if (!skipFocus) toggle.focus({ preventScroll: true });
      }

      function expand() {
        container.classList.add('is-expanded');
        body.style.maxHeight = body.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
        label.textContent = collapseLabel;
      }

      body.style.maxHeight = collapsedHeight + 'px';
      requestAnimationFrame(function() {
        if (body.scrollHeight > collapsedHeight + 8) toggle.hidden = false;
      });

      toggle.addEventListener('click', function() {
        if (container.classList.contains('is-expanded')) collapse(false);
        else expand();
      }, { signal: controller.signal });

      window.addEventListener('resize', function() {
        lines = parseInt(getComputedStyle(container).getPropertyValue('--np-description-lines'), 10) || 6;
        lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 27;
        collapsedHeight = Math.ceil(lines * lineHeight);
        body.style.maxHeight = (container.classList.contains('is-expanded') ? body.scrollHeight : collapsedHeight) + 'px';
      }, { signal: controller.signal });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initExpandableDescriptions(document); });
  } else {
    initExpandableDescriptions(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initExpandableDescriptions(event.target); });
  document.addEventListener('shopify:section:unload', function(event) { event.target.querySelectorAll('[data-np-expandable-description]').forEach(function(container) { if (container._npCleanup) container._npCleanup(); }); });
})();

